export default {
  brand: "USFansSheet",
  nav: {
    home: "Strona główna",
    categories: "Kategorie",
    guides: "Poradniki",
    guide: "Poradnik zakupów",
    faq: "FAQ",
    safety: "Bezpieczeństwo",
    mainWebsite: "Główna strona",
  },
  hero: {
    badge: "Niezależne źródło zakupowe",
    title: "Mądrzejszy sposób na poznanie arkusza USFans Spreadsheet",
    subtitle: "Przeglądaj uporządkowane kategorie produktów, informacje o sprzedawcach, wskazówki QC, szczegóły wysyłki i porady dotyczące bezpieczeństwa — wszystko w jednym miejscu.",
    ctaPrimary: "USFans Spreadsheet",
    ctaSecondary: "Kup teraz",
    ctaGuide: "Przeczytaj poradnik USFans",
    trust: "Niezależne źródło · Regularnie aktualizowane · Wielojęzyczne",
  },
  categories: {
    title: "Kupuj według kategorii",
    subtitle: "Przeglądaj każdą kategorię produktów w arkuszu USFans Spreadsheet. Wybierz kategorię, aby otworzyć ją na głównej stronie.",
    dropdownLabel: "Wszystkie kategorie",
    dropdownHint: "Wybierz kategorię",
    popularTitle: "Popularne kategorie",
    viewAll: "Zobacz wszystkie kategorie",
  },
  intro: {
    eyebrow: "Co to jest",
    title: "Czym jest arkusz USFans Spreadsheet?",
    p1: "Arkusz USFans Spreadsheet to uporządkowane zestawienie, które łączy listy produktów, kategorie i szczegóły zakupów w prostym formacie tabeli. Zamiast skakać między wieloma stronami, otwierasz jedno miejsce, aby przejrzeć produkty, sprawdzić kategorie i znaleźć potrzebne linki.",
    p2: "Naszym celem w USFansSheet jest ułatwienie tych poszukiwań — dzięki przejrzystym skrótom do kategorii, rzetelnym wskazówkom i poradom dotyczącym QC, wysyłki i bezpieczeństwa, zanim przejdziesz do głównego źródła.",
    cta: "Odkryj arkusz USFans Spreadsheet",
  },
  articles: {
    eyebrow: "Poradniki",
    title: "Poradniki USFans Spreadsheet",
    subtitle: "Czytaj oryginalne, łatwe do zrozumienia poradniki, aby badać produkty, sprzedawców, QC, wysyłkę i bezpieczeństwo.",
    readMore: "Czytaj poradnik",
    featured: "Wyróżniony poradnik",
    comingSoon: "Wkrótce",
    viewAll: "Zobacz wszystkie poradniki",
  },
  faq: {
    eyebrow: "FAQ",
    title: "Najczęściej zadawane pytania",
    subtitle: "Szybkie odpowiedzi na najczęstsze pytania dotyczące arkusza USFans Spreadsheet.",
    q1: "Czym jest arkusz USFans Spreadsheet?",
    a1: "To uporządkowany dokument, który w tabeli zestawia produkty, kategorie i szczegóły zakupów, używany jako punkt wyjścia do badań.",
    q2: "Jak korzystać z arkusza USFans Spreadsheet?",
    a2: "Otwórz potrzebną kategorię, przejrzyj wiersze produktów, sprawdź notatki QC lub wysyłki, a następnie przejdź linkami na główną stronę.",
    q3: "Czy USFans jest wiarygodny?",
    a3: "Dostarczamy niezależne informacje, aby pomóc w badaniu. Zawsze weryfikuj aktualne dane w oficjalnych źródłach przed zakupem.",
    q4: "Czy arkusz obejmuje koszty wysyłki?",
    a4: "Wiele ofert zawiera notatki o wysyłce, ale ostateczne koszty zależą od wagi, metody i miejsca docelowego.",
    q5: "Czy potrzebuję konta, aby przeglądać?",
    a5: "Przeglądanie zasobów jest zwykle otwarte, ale zawsze potwierdzaj wymagania konta na oficjalnej stronie.",
  },
  cta: {
    title: "Gotowy, aby odkryć więcej?",
    subtitle: "Skorzystaj z naszych poradników, aby zbadać USFans, porównać informacje i zrozumieć najważniejsze czynniki przed przejściem do głównego źródła.",
    primary: "Odwiedź główną stronę",
    secondary: "Zobacz wszystkie poradniki",
  },
  footer: {
    description: "USFansSheet to niezależne źródło informacji skoncentrowane na arkuszu USFans Spreadsheet, pomagające badać produkty, kategorie, QC, wysyłkę i bezpieczeństwo.",
    explore: "Odkrywaj",
    resources: "Zasoby",
    categories: "Kategorie",
    guides: "Poradniki",
    faq: "FAQ",
    mainWebsite: "Główna strona",
    disclaimer: "USFansSheet.guru to niezależne źródło informacji i nie jest powiązane ani oficjalnie popierane przez USFans, chyba że wyraźnie zaznaczono. Zawsze weryfikuj aktualne informacje w oficjalnych źródłach przed dokonaniem zakupów lub decyzji finansowych.",
    rights: "Wszelkie prawa zastrzeżone.",
  },
  cat: {
    shoes: "Buty",
    hoodies: "Bluzy / Swetry",
    tshirts: "Koszulki",
    jackets: "Kurtki",
    pants: "Spodnie / Szorty",
    headwear: "Nakrycia głowy",
    sets: "Zestawy",
    underwear: "Bielizna / Majtki",
    jersey: "Koszulka sportowa",
    accessories: "Akcesoria",
    bags: "Torby",
    belts: "Paski",
    perfumes: "Perfumy",
    other: "Inne rzeczy",
  },
  article: {
    breadcrumbHome: "Strona główna",
    breadcrumbGuides: "Poradniki",
    notFoundTitle: "Nie znaleziono poradnika",
    notFoundDesc: "Poradnik, którego szukasz, nie jest dostępny. Wróć na stronę główną, aby przejrzeć wszystkie nasze zasoby.",
    backHome: "Wróć na stronę główną",
    updated: "Zaktualizowano",
    relatedTitle: "Powiązane poradniki",
    ctaTitle: "Kontynuuj badania",
    ctaDesc: "Po przeczytaniu tego poradnika możesz przeglądać kategorie produktów lub przejść bezpośrednio na główną stronę, aby poznać pełne źródło.",
    ctaMain: "Odwiedź główną stronę",
  },
};